/*
 * Title: 회원초대 서비스
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 * @Object: GentleServiceInviteMember
 * @Property Value
 * - sponserId: 후원인 아이디 
 * - sponserName: 후원인 이름 
 * @Property Method
 * - selectInviteType: 회원초대방식선택
 * - sponserIsMe: 원인으로 초대장 생성
 * - sponserIsOther: 다른 사람을 후원인으로 초대장 생성 
 * - createSimpleMemberRegister: 실제 초대장 생성
 */

import GentleWidget from '../common/widget';
import GentleUtil from '../common/util';
import GentleComponentButton from '../component/button';
import GentleComponentBubble from '../component/bubble';
import GentleLang from '../common/lang';
import GentleProxy from '../common/proxy';
import GentleAppState from '../common/appstate';
import language from '../lang';

var GentleServiceInviteMember = Object.create( GentleWidget,{
    sponserId:{ writable: true, configurable: false, enumerable: true},
    sponserName: { writable: true, configurable: false, enumerable: true}
})

GentleServiceInviteMember.main = function(){
    console.log('GentleServiceInviteMember.main');
    // 버블 

    {
        const bubble = GentleUtil.notSupported();
        bubble.insert();
        return;
    }
        
    var bubble = Object.create( GentleComponentBubble );   
    bubble.createComponent({
            "html": GentleLang.translateService(language.invite, language.invite.type.Bot),
    });
    bubble.insert();

    // 버튼 : 나를 후원인으로 설정
    {
        var button = Object.create( GentleComponentButton );
        const text = GentleLang.translateService(language.invite, language.invite.type.ButtonSelectMe);
        button.createComponent(
            {
                send: false,
                text,
                onClick: function(){
                    const {custName, custNo} = GentleAppState;
                    request(custNo, custName, function(StatusDetailCode){
                        switch (StatusDetailCode) {
                            case '001': // 검색 후원인 없음
                                break;
                            case '002': // 후원인 좌/우 빈곳없음
                                // bubble
                                {
                                    const msg1 = GentleLang.translateService(language.invite, language.invite.type.YouCant, {name: custName});
                                    const msg2 = GentleLang.translateService(language.invite, language.invite.type.InviteOther);

                                    var bubble = Object.create( GentleComponentBubble );   
                                    bubble.createComponent({
                                            "html": [msg1, msg2],
                                    });
                                    bubble.insert();
                                }

                                // button
                                {
                                    var button = Object.create( GentleComponentButton );
                                    const text = GentleLang.translateService(language.invite, language.invite.type.ButtonSelectOther);
                                    button.createComponent(
                                        {
                                            send: false,
                                            text,
                                            "onClick":function(){
                                                GentleServiceInviteMember.sponserIsOther();
                                            }
                                        }
                                    );    
                                    button.insert();
                                }
                             
                                break;
                            case '003': // 기타오류
                                break;
                            default:
                                break;
                        }                        
                    });
                    // GentleServiceInviteMember.createSimpleMemberRegister({custName, custNo});
                }
            }
        );    
        button.insert();
    }
    // 다른 회원을 후원인으로 설정
    {
        var button = Object.create( GentleComponentButton );
        const text = GentleLang.translateService(language.invite, language.invite.type.ButtonSelectOther);
        button.createComponent(
            {
                send: false,
                isSecondary: true,
                text,
                "onClick":function(){
                    GentleServiceInviteMember.sponserIsOther();
                }
            }
        );    
        button.insert();
    }
}

// 초대장 만들기
const request = function(HuwonNo, CustName, fail=null){
    console.log('HuwonNo>', HuwonNo);
    const onSuccess = function(data){
        console.log('onSuccess>', data);
        let { Status, StatusDetailCode, Data } = data;
        console.log('Data>', Data);
        switch(Status){
        case 1:
            data.custName = CustName;
            data.custNo = HuwonNo;

            GentleUtil.removeSlidePopup();
            GentleServiceInviteMember.createSimpleMemberRegister(data);
            break;
        case 50:
            if(fail){
                fail(StatusDetailCode);
            }
            else{
                switch (StatusDetailCode) {
                    case '001': // 검색 후원인 없음
                        $comment.html(GentleLang.translateService(language.invite, language.invite.type.NotFound));
                        break;
                    case '002': // 후원인 좌/우 빈곳없음
                        $comment.html(GentleLang.translateService(language.invite, language.invite.type.NotEmpty));
                        break;
                    case '003': // 기타오류
                        $comment.html(GentleLang.translateService(language.invite, language.invite.type.NotFound));
                        break;
                    default:
                        break;
                }
                
                {
                    $comment.show();
                    $result.hide();
                    $userID.html('');
                    $userName.html('');
                }
            }
            break;
        default:
            break;
        }
    };

    const onFailed = function(data){
        console.log('onFailed');
    }

    // todo : 후원인 검색 api???
    const proxy = Object.create(GentleProxy);

    const CustNo = GentleAppState.custNo;
    const param = {CustNo, HuwonNo};

    proxy.request("easyjoin", param, onSuccess, onFailed );
}

// 후원인 검색
GentleServiceInviteMember.find = function(){
    console.log('GentleServiceInviteMember.find');

    {
        const bubble = GentleUtil.notSupported();
        bubble.insert();
        return;
    }

    let $result;
    let $userName;
    let $userID;
    let $input_search;
    let $comment, HuwonNo;

    let CustName;

    const failedMsg = function(){
        $comment.html(GentleLang.translateService(language.invite, language.invite.type.NotFound));
    }

    const notExistMsg = function(){
        
        $comment.html(GentleLang.translateService(language.invite, language.invite.type.NotFoundID));
    }
    // api
    // 단순 회원 찾기
    const search = function(searchNo){
        HuwonNo = '';
        console.log('HuwonNo>', searchNo);
        if(searchNo === ''){
            notExistMsg();
        }
        const onSuccess = function(data){
            console.log('onSuccess>', data);
            const { Status, StatusDetailCode, Data } = data;
            console.log('Data>', Data);

            switch(Status){
            case 1:
                if(Data){
                    $result.show();
                    $comment.hide();
                    CustName = Data.CustName;
                    HuwonNo = searchNo;
                    $userID.html(searchNo);
                    $userName.html(CustName);
                }else{
                    $comment.html(GentleLang.translateService(language.invite, language.invite.type.NotFound));
                }
                break;
            default:
                $comment.show();
                $result.hide();
                $userID.html('');
                $userName.html('');
            break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
            // todo : 결과가 없을때 404가 나오네... 
            // $comment.html(GentleLang.translateService(language.invite, language.invite.type.NotFound));\
            if(searchNo === ''){
                notExistMsg();
            }else{
                failedMsg();
            }
            
        }

        // todo : 후원인 검색 api???
        const proxy = Object.create(GentleProxy);

        const CustNo = GentleAppState.custNo;
        const param = {searchNo};

        // proxy.request("sponsor", param, onSuccess, onFailed );
        proxy.requestEx({proxy: "sponsor", param, onSuccess, onFailed, isHidden:true });
    }

    const render = function(data){
        const title = GentleLang.translateService(language.invite, language.invite.type.FindSponser) ;
        const placeholder = GentleLang.translateService(language.invite, language.invite.type.PlaceholderID) ;
        const comment = GentleLang.translateService(language.invite, language.invite.type.SearchComment) ;  

        let html = `
        <div id="support-member-select">
            <div class="search-field">
                <input type="text" placeholder="${placeholder}" >
                <i class="at-icon at-search at-3x"></i>
            </div>   
            <div id="support-member-content">
                <p class="notice" name="comment">${comment}</p>
                <ul class = "card-list support-member" >
                    <li name="result">
                        <div class="flex-box">
                            <h6 name="username">${CustName}</h6>
                            <span name="userid">${HuwonNo}</span>
                            <div>
                                <i class="at-check"></i>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>`;

        let $container = $(html)

        // bind
        {
            $result = $container.find('[name="result"]');
            $result.hide();
            $result.bind('click',function() {
                console.log('후원인 선택');
                request(HuwonNo, CustName, function(StatusDetailCode){
                    switch (StatusDetailCode) {
                        case '001': // 검색 후원인 없음
                            $comment.html(GentleLang.translateService(language.invite, language.invite.type.NotFound));
                            break;
                        case '002': // 후원인 좌/우 빈곳없음
                            const name = GentleAppState.custName;
                            $comment.html(GentleLang.translateService(language.invite, language.invite.type.NotEmpty, {name:CustName}));
                            break;
                        case '003': // 기타오류
                            $comment.html(GentleLang.translateService(language.invite, language.invite.type.NotFound));
                            break;
                        default:
                            break;
                    }
                    {
                        $comment.show();
                        $result.hide();
                        $userID.html('');
                        $userName.html('');
                    }
                });
            });

            $userName = $container.find('[name="username"]');
            $userID = $container.find('[name="userid"]');
            $comment = $container.find('[name="comment"]');
            // $userName = component.find('[name="username"]');
            // $userID = component.find('[name="userid"]');
            $comment = $container.find('[name="comment"]');
        }

        $input_search = $container.find('input');
        $input_search.blur(function(){
            GentleUtil.fillAuto($input_search);
        });

        // 검색
        {
            const doSearch = function(){
                GentleUtil.fillAuto($input_search);
                
                const text = $input_search.val();
                $comment.show();
                $result.hide();
                GentleUtil.serviceLoadingShow();
                search(text);
            }

            // $input_search = component.find('input');
            $input_search.keydown(function(key) {
                if (key.keyCode == 13) {
                    const text = $input_search.val();
                    doSearch(text);
                    $input_search.val('');

                    $input_search.attr("readonly",true);
                    $input_search.focus();
                    setTimeout(function(){ $input_search.attr("readonly",false);}, 50);
                }
            });

            $container.find('.at-search').bind('click',function() {
                console.log('...');
                doSearch();
            });
        }

        // button
        $container.find('button').bind('click',function() {
        // component.find('button').bind('click',function() {
                console.log('더보기')
            }
        );

        GentleUtil.createSlidePopup({title, content: $container});
    };
    render();
}

// 다른사람을 후원인으로 설정 
GentleServiceInviteMember.sponserIsOther = function(){
    console.log('GentleServiceInviteMember.sponserIsOther');
    const component =  Object.create(this);
    const JisaCode = GentleAppState.lang;

   // 버블 
   var bubble = Object.create( GentleComponentBubble );   
   bubble.createComponent({
           "html": GentleLang.translateService(language.invite, language.invite.type.SelectSponsor),
   });
   bubble.insert();

   // 버튼
   var button = Object.create( GentleComponentButton );
   button.createComponent([
       {
           "text": GentleLang.translateService(language.invite, language.invite.type.FindSponser),
           "onDisableAfterClick": false,
           "isHidden": true,
           "onClick": function(){
               // 슬라이드 팝업 컨텐츠 생성 
               console.log('후원인 검색');

                var html = GentleLang.translateService(language.invite, language.invite.type.FindSponser);
               //GentleUtil.slidePopupOpen(html);

               // todo : 후원인 검색 > 아이디 입력 > 조회
               GentleServiceInviteMember.find();
           }
       }
   ]);
   button.insert();

   GentleUtil.timeStamp();
}

// 초대장 생성 
GentleServiceInviteMember.createSimpleMemberRegister = function(data){
    console.log('GentleServiceInviteMember.createSimpleMemberRegister', data);

    const {custName, custNo, Data} = data;
    const {MobileUrl, PCUrl} = Data;

    if( custName === undefined ) throw new Error('후원인 이름이 전달되지 않았습니다');
    // if( this.name === undefined || this.family === undefined) throw new Error('후원인 이름이 전달되지 않았습니다');
    if( custNo === undefined ) throw new Error('후원인 ID가 전달되지 않았습니다');
    //후원인이 내가 아닌 경우에는 해당하는 버블을 출력
    if(custName !== GentleAppState.custName || custNo !== GentleAppState.custNo){
        {    
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                "html": GentleLang.translateService(language.invite, language.invite.type.OtherHuwonComplete) ,
            });
            bubble.insert();    
        }
        {
            const component =  Object.create(this);
    
            const title = GentleLang.translateService(language.invite, language.invite.type.Card) ; // 
            const titleSponsor = GentleLang.translate(GentleLang.type.Sponsor) ; // 
            const titleCustNo = GentleLang.translate(GentleLang.type.CustNo) ; // 
            const comment = GentleLang.translateService(language.invite, language.invite.type.CardComment) ; // 
            const caution = GentleLang.translateService(language.invite, language.invite.type.CardCaution) ; // 
            const button_title = GentleLang.translateService(language.invite, language.invite.type.CopyLink);   // 초대장 링크 복사
    
            let html = `
            <div class="card-view invite-member">
                <div class="invite-member-container">
                    <div class="bg-container">
                        <h3>${comment}</h3>
                        <div class="flex-box-2">
                            <span>${titleSponsor}</span>
                            <span>${custName}</span>
                        </div>
                        <div class="flex-box-2">
                            <span>${titleCustNo}</span>
                            <span>${custNo}</span>
                        </div>
                    </div>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button type="button" class="primary default">${button_title}</button>
                        </div>
                    </div>
                    <p class="text-tip">${caution}</p>
                </div>
            </div>        
            `    
            // component 초기화. 이 코드 후에 레퍼런스로 접근
            let $container = $(html)
            $container.find('button').eq(0).bind('click',
            function() {
                const copyString = MobileUrl;
                const successMsg = GentleLang.translateService(language.invite, language.invite.type.Copied);
                const failedMsg = '상품 링크 복사에 실패했습니다';
        
                GentleUtil.copyTextToClipboard(copyString, function(result){
                    if(result === true){
                        GentleUtil.createToastMessage(successMsg);
                    }else{
                        GentleUtil.createToastMessage(failedMsg);
                    }
                });
            });    

            {
                component.setPrefix("search");
                component.init($container);
                component.insert();
            }

            console.log('log3', $container.find('button'));

            // 초대장 링크복사
    
            // component.find('button').eq(1).on('click', function(){
            //     const copyString = 'http://www.gentlepie.com';
            //     const successMsg = '상품 링크가 복사되었습니다';
            //     const failedMsg = '상품 링크 복사에 실패했습니다';
        
            //     GentleUtil.copyTextToClipboard(copyString, function(result){
            //         if(result === true){
            //             GentleUtil.createToastMessage(successMsg);
            //         }else{
            //             GentleUtil.createToastMessage(failedMsg);
            //         }
            //     });
            // });    
    
            GentleUtil.timeStamp();
        }
    }else{

    
    // 버블 
    {
        const name = custName;

        var bubble = Object.create( GentleComponentBubble );   
        bubble.createComponent({
            "html": GentleLang.translateService(language.invite, language.invite.type.BotComplete, {name}) ,
        });
        bubble.insert();    
    }
    {
        var bubble = Object.create( GentleComponentBubble );   
        bubble.createComponent({
            "html": GentleLang.translateService(language.invite, language.invite.type.BotLink),
        });    
        bubble.insert();    
    }

    // card
    {
        const component =  Object.create(this);

        const title = GentleLang.translateService(language.invite, language.invite.type.Card) ; // 
        const titleSponsor = GentleLang.translate(GentleLang.type.Sponsor) ; // 
        const titleCustNo = GentleLang.translate(GentleLang.type.CustNo) ; // 
        const comment = GentleLang.translateService(language.invite, language.invite.type.CardComment) ; // 
        const caution = GentleLang.translateService(language.invite, language.invite.type.CardCaution) ; // 
        const button_title = GentleLang.translateService(language.invite, language.invite.type.CopyLink);   // 초대장 링크 복사

        let html = `
        <div class="card-view invite-member">
            <div class="invite-member-container">
                <div class="bg-container">
                    <h3>${comment}</h3>
                    <div class="flex-box-2">
                        <span>${titleSponsor}</span>
                        <span>${custName}</span>
                    </div>
                    <div class="flex-box-2">
                        <span>${titleCustNo}</span>
                        <span>${custNo}</span>
                    </div>
                </div>
                <div class="gentle-button-group">
                    <div class="wide-button">
                        <button type="button" class="primary default">${button_title}</button>
                    </div>
                </div>
                <p class="text-tip">${caution}</p>
            </div>
        </div>        
        `

        // component 초기화. 이 코드 후에 레퍼런스로 접근
        {
            let $container = $(html)
            component.setPrefix("search");
            component.init($container);
            component.insert();
        }

        // 초대장 링크복사
        component.find('button').bind('click',
        function() {
            const copyString = 'http://www.gentlepie.com';
            const successMsg = GentleLang.translateService(language.invite, language.invite.type.Copied);
            const failedMsg = '상품 링크 복사에 실패했습니다';
    
            GentleUtil.copyTextToClipboard(copyString, function(result){
                if(result === true){
                    GentleUtil.createToastMessage(successMsg);
                }else{
                    GentleUtil.createToastMessage(failedMsg);
                }
            });
        });    

        // component.find('button').eq(1).on('click', function(){
        //     const copyString = 'http://www.gentlepie.com';
        //     const successMsg = '상품 링크가 복사되었습니다';
        //     const failedMsg = '상품 링크 복사에 실패했습니다';
    
        //     GentleUtil.copyTextToClipboard(copyString, function(result){
        //         if(result === true){
        //             GentleUtil.createToastMessage(successMsg);
        //         }else{
        //             GentleUtil.createToastMessage(failedMsg);
        //         }
        //     });
        // });    

        GentleUtil.timeStamp();
    }
}
}

export default GentleServiceInviteMember;